<section class="wrapper image-wrapper bg-image bg-light-shock text-dark">
    <div class="container pt-5 pb-20 pt-md-10 pb-md-20 text-center">
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <!-- /nav -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->
  <section class="wrapper bg-light">
    <div class="container pb-5 pb-md-5">
      <div class="row">
        <div class="col-lg-7 col-xl-6 col-xxl-5 mx-auto mt-n20">
          <div class="card">
            <div class="card-body px-lg-11 pb-lg-11 pt-lg-10 text-center">
              <h2 class="pb-5 text-center">Welcome To Wanted Drivers</h2>
              <form class="text-start pb-3" [formGroup]="loginform" autocomplete="off">
                <div class="form-floating mb-4">
                  <!-- <input class="form-control"  id="loginEmail" formControlName="email" type="email" maxlength="200" autocomplete="off"> -->
                   <input class="form-control"
                      id="loginEmail"
                      formControlName="email"
                      type="text"
                      placeholder="Enter Email"
                      autocomplete="new-email"
                      autocapitalize="off"
                      autocorrect="off"
                      spellcheck="false">
                  <label for="loginEmail">Email</label>
                  <div *ngIf="!loginControl.email?.valid && (loginControl.email?.dirty ||loginControl.email?.touched)" class="mele_error">
                    <div [hidden]="!loginControl.email.errors?.['required']">
                        Email ID is Required
                    </div>
                    <div [hidden]="!loginControl.email.errors?.['pattern']">
                        Please Enter Valid Email ID
                      </div>
                  </div>
                </div>
                <div class="form-floating password-field mb-4">
                  <!-- <input type="password" class="form-control" id="loginPassword" autocomplete="off" [type]="fieldTextType ? 'text' : 'password'" maxlength="16" formControlName="password" required> -->
                   <input class="form-control"
                      id="loginPassword"
                      [type]="fieldTextType ? 'text' : 'password'"
                      formControlName="password"
                      placeholder="Enter Password"
                      autocomplete="new-password"
                      autocapitalize="off"
                      autocorrect="off"
                      spellcheck="false">
                  <span class="password-toggle"><i class="uil uil-eye" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}" (click)="toggleFieldTextType()" style="line-height: 2; cursor: pointer;"></i></span>
                  <label for="loginPassword">Password</label>
                  <div *ngIf="!loginControl.password?.valid && (loginControl.password?.dirty ||loginControl.password?.touched)" class="mele_error">
                    <div [hidden]="!loginControl.password.errors?.['required']">
                        Password is Required
                    </div>
                  </div>
                </div>
                <div class="text-center mt-6 mb-2">
                  <a class="btn btn-danger rounded-pill btn-login w-50" (click)="loginWithToken()">Sign In</a>
                </div>
              </form>
              <!-- /form -->
              <p class="mb-1"><a routerLink="/forgotpwd" class="hover">Forgot Password?</a></p>
              <p class="mb-0">Don't have an account? <a routerLink="/register" class="hover">Sign up</a></p>
              <div class="divider-icon my-4">or</div>
              <nav class="nav social justify-content-center text-center align-items-center">
                <asl-google-signin-button type='standard' size='large' class="btn btn-circle btn-sm btn-google"></asl-google-signin-button>
                <!-- <button type="button" (click)="signInWithFB()" matTooltip="signin with facebook" class="mx-3 btn btn-primary btn-sm  btn-block"><i class="uil uil-facebook-f"></i></button> -->
              </nav>
              <!--/.social -->
            </div>
            <!--/.card-body -->
          </div>
          <!--/.card -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>